export default {
  state: {    
    // Порядок ВАЖЕН!!! В этом порядке человек проходит по режимам каждого упражнения
    idModes0: ["Hor-0","Sp-0","Sch-0"], // Regime
    idModes0Names: ["Слушаем","Говорим","Пишем"], 
    erSatzLevel:0.8, // уровень выше которого переход на следующий шаг process 

    modes: [],
    mode: {},    
    videos: [],
    video: {},
    typeSet: null,
    /* массив объектов
      progressModeRegime = {
        idMode:
        idMode0:
        erSatz:            
        }                 */
    progressModes :[],
    /* id video или mode, который нужно делать сейчас согласно process и условиям выполнения
     если это mode то второе значение - это idMode0 , который нужно делать сейчас
     если это video то второе значение null      
     третье значение - это индекс в progressModes по которому находится этот id video или mode
     */         
     doNow:[]
  },
  getters: {  
    erSatzLevel(state) {
      return state.erSatzLevel
    },
    idModes0(state) {
      return state.idModes0
    },
    idModes0Names(state) {
      return state.idModes0Names
    },
    modes(state) {
      return state.modes
    },
    mode(state) {
      return state.mode
    },
    videos(state) {
      return state.videos
    },
    video(state) {
      return state.video
    },
    typeSet(state) {
      return state.typeSet
    },
    progressModes (state){
      return state.progressModes
    },
    doNow (state){
      return state.doNow
    }
  },
  mutations: {    
    clearCourseState(state){  
      state.modes= [],
      state.mode= {},    
      state.videos= [],
      state.video= {},
      state.typeSet= null,
      state.doNow=[]      
    },
    clearCourseModeVideoState(state){        
      state.mode= {},          
      state.video= {},
      state.typeSet= null      
    },
    updateCourseModes(state, modes) {
      state.modes = modes
    },
    setMode(state, {mode}) {
      state.mode = mode;      
      state.typeSet = 'mode';      
    },
    updateCourseVideos(state, videos) {
      state.videos = videos
    },
    setVideo(state, video) {
      state.video = video;
      state.typeSet = 'video';
    },
    setProgressModes(state, progressModes) {
      state.progressModes = progressModes;      
    },
    setDoNow(state, doNow) {
      state.doNow = doNow;      
    }
  },
  actions: {
    async getCourseModes({ dispatch, commit }, { idUser, id }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourseModes",
          pathVariable: null,
          data: { idUser, id }
        });
        if (objectResponse.bodyJson) {
          commit("updateCourseModes", objectResponse.bodyJson)
        }        
      } catch (e) { }
    },
    async getCourseVideos({ dispatch, commit }, { idUser, id }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourseVideos",
          pathVariable: null,
          data: { idUser, id }
        });
        if (objectResponse.bodyJson) {
          commit("updateCourseVideos", objectResponse.bodyJson)
        }        
      } catch (e) { }
    },
  }

}
